<template>
  <b-tab active>
    <template v-slot:title>Members</template>
    <div>

      <!-- Major Permissions -->
      <h4 class="text-black">View Members</h4>
      <div class="mb-2 border-bottom row" v-for="(item, index) in permissions" :key="index">
        <div class="col-2">{{ item.rolename }}</div>
        <div class="col">
          <RockerSwitch v-if="item.view_members == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'view_members')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'view_members')" />
        </div>
      </div>

      <div>
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-2">New Member</div>
          <div class="col-2">Edit Member</div>
          <div class="col-2">Delete Member</div>
          <div class="col-3">View Member Balances</div>
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- New Member -->
          <div class="col-2">
            <RockerSwitch v-if="item.new_member == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'new_member')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'new_member')" />
          </div>

          <!-- Edit Member -->
          <div class="col-2">
            <RockerSwitch v-if="item.edit_member == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'edit_member')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'edit_member')" />
          </div>

          <!-- Delete Member -->
          <div class="col-2">
            <RockerSwitch v-if="item.delete_member == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'delete_member')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'delete_member')" />
          </div>

          <!-- View Balances -->
          <div class="col-3">
            <RockerSwitch v-if="item.view_balances == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'view_balances')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'view_balances')" />
          </div>
        </div>
      </div>
      <hr>
      <h4 class="text-black">Applicants</h4>
      <div class="row fw-bold text-black mb-2">
        <div class="col-2">Role Name</div>
        <div class="col-2">View Applicants</div>
        <div class="col-3">Approve Applicants</div>
      </div>
      <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
        <div class="col-2">{{ item.rolename }}</div>

        <!-- View Applicants -->
        <div class="col-2">
          <RockerSwitch v-if="item.view_applicants == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'view_applicants')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'view_applicants')" />
        </div>

        <!-- Approve Applicants -->
        <div class="col-3">
          <RockerSwitch v-if="item.approve_applicant == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'approve_applicant')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'approve_applicant')" />
        </div>
      </div>
    </div>
  </b-tab>
</template>

<script>
import axios from "axios";
import RockerSwitch from "vue-rocker-switch";
import "vue-rocker-switch/dist/vue-rocker-switch.css";

import appConfig from "@/app.config";
import { permissionMethods } from "@/state/helpers";

export default {
  name: "MemberPermissions",
  page: {
    title: "System Permissions",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  props: {
    permissions: Array,
  },
  components: {
    RockerSwitch
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Permissions",
      items: [{ text: "Dashboard", to: "/", }, { text: "System Permissions", active: true, },],
      isBusy: true,
      role: '',
      permission: '',
    };
  },
  computed: {
    filteredPermissions() {
      return this.permissions.filter((permission) => permission.view_members == 1);
    },
  },

  methods: {
    ...permissionMethods,
    async changePermission(role, permission) {
      this.role = role;
      this.permission = permission;
      let formData = new FormData();
      formData.append("role", this.role);
      formData.append("permission", this.permission);
      let url = "/updatepermission";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPermissions();
          this.role = "";
          this.permission = "";
        }
      });
    },
  },
};
</script>